import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.min((scrollY / docHeight) * 100, 100) : 0;

      setVisible(scrollY > 400);
      setProgress(pct);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // SVG circle progress ring
  const size = 48;
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className={`fixed bottom-7 right-7 z-50 flex flex-col items-center gap-2 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
    >
      {/* Tooltip */}
      <div
        className={`bg-navy-900 text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap shadow-lg transition-all duration-300 ${
          hovered ? 'opacity-100 -translate-y-1' : 'opacity-0 translate-y-1 pointer-events-none'
        }`}
      >
        Back to top
      </div>

      {/* Button */}
      <button
        onClick={scrollToTop}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Back to top"
        className="relative flex items-center justify-center cursor-pointer group"
        style={{ width: size, height: size }}
      >
        {/* Progress ring */}
        <svg
          width={size}
          height={size}
          className="absolute inset-0 -rotate-90 transition-all duration-300"
        >
          {/* Track */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="rgba(196,154,58,0.2)"
            strokeWidth="3"
          />
          {/* Progress */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="rgb(196,154,58)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            className="transition-all duration-200"
          />
        </svg>

        {/* Inner circle button */}
        <div className="relative z-10 w-9 h-9 rounded-full bg-gold-500 group-hover:bg-gold-400 flex items-center justify-center shadow-[0_4px_20px_rgba(196,154,58,0.5)] group-hover:shadow-[0_6px_28px_rgba(196,154,58,0.7)] transition-all duration-300 group-hover:scale-110">
          <i className="ri-arrow-up-line text-navy-900 text-base font-bold transition-transform duration-300 group-hover:-translate-y-0.5"></i>
        </div>
      </button>
    </div>
  );
}